
import axios from 'axios';
import qs from 'qs';
const { REACT_APP_ENV } = process.env;
var apiConfig = require('../Services/constant.json')[REACT_APP_ENV.trim()];

const getRefreshToken = async () => {
    return new Promise(async (resolve, reject) => {
       
        const userinfo = await localStorage.getItem('userinfo');
        
        var data = {
            grant_type: 'refresh_token',
            client_id: apiConfig.cognito.userPoolWebClientId,
            refresh_token: JSON.parse(userinfo).signInUserSession.refreshToken.token
        };
        
        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data),
            url: `https://${apiConfig.cognito.oauth.domain}/oauth2/token`,
        };
        axios(options)
            .then(async function (response) {
                if (response.status != 200) {
                    reject();
                } else {
                    await localStorage.setItem('token', response.data.id_token);
                    resolve();
                }
            })
            .catch(err => {
                reject();
            })
    })

}
export default getRefreshToken;